/**
 * Request deduplication utility.
 * 
 * When multiple callers request the same URL simultaneously,
 * only ONE actual network request is sent. All callers get the same response.
 * 
 * This eliminates the burst of 4-6 identical unread-count / notifications
 * requests that fire on page load and tab switch.
 */
import axios from 'axios';

const _inflight = new Map();

/**
 * Deduplicated GET request. If a request to the same URL is already in-flight,
 * returns the existing promise instead of firing a new one.
 */
export function dedupedGet(url, config = {}) {
  const key = url;
  if (_inflight.has(key)) {
    return _inflight.get(key);
  }
  const promise = axios.get(url, config).finally(() => {
    _inflight.delete(key);
  });
  _inflight.set(key, promise);
  return promise;
}
